export const PASSWORD_CLIENT_ROUTE = {
  forgot: '/password/forgot',
  setup: '/password/setup',
};
